import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import { thunk } from 'redux-thunk';
import rootReducer from './reducers/Reducers'; // Importa tu combinador de reductores

//https://github.com/rt2zz/redux-persist/issues/1246
// Configuración de redux-persist
const persistConfig = {
  key: 'bookingengine',
  storage: {
    ...storageSession,
    setItem: (key, item) => new Promise((resolve) => {
      resolve(storageSession.setItem(key, JSON.stringify(item)));
    }),
    getItem: (key) => new Promise((resolve) => {
      storageSession.getItem(key).then((value) => resolve(value ? JSON.parse(value) : null));
    }),
  },
  serialize: false,
  deserialize: false,
};

// Crear el persist reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configuración del store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
  // Otras opciones de configuración si es necesario
});

// Crear el persist store
const persistor = persistStore(store);

export { store, persistor };

/*
//anteriormente teniamos:
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from './reducers/Reducers'; // Ajusta la ruta si es necesario
import { persistReducer, persistStore } from 'redux-persist';
import {thunk} from 'redux-thunk';
import storageSession from 'redux-persist/lib/storage/session'

const persistConfig = {
  key: 'bookingengine',
  storage: storageSession,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk]
})

export const persistor = persistStore(store)

*/
